<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <div class="card">
                <div class="card-header text-center" style="background:#9b7544">
                    <h5><p style="color:#fff;font-style: open sans; overflow-wrap:break-word">
                        Enter Your Schedule For  ... {{day}}</p></h5></div>
                            <form (ngSubmit)="addMySchedule(f1)" #f1="ngForm" style="margin-top:20px">
                         <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="form-group">
                                        <label for="stime">Enter Start Time</label>
                                         <input type="time" name="stime" id="stime" ngModel   required>
                                 </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="form-group">
                                     <label for="etime">End Time</label>
                                       <input type="time" name="etime" id="etime" ngModel  required>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                                <div class="col-6">
                                 <div class="form-group">
                                     <label for="sd">Slot Duration</label>
                                        <input type="number" name="sd" id="sd" ngModel  required>
                                    </div>
                                </div>
                                <div class="col-6">
                                       
                                              
                                                    <div class="row" *ngIf="clinic">
                                                        <div class="col-3">
                                                                <label>Select Clinic</label>
                                                        </div>
                                                        <div class="col-9" >
                                                                <select style="width:100%"   type="text" id="cl"  name="cl"   ngModel  required>
                                                                 <option *ngFor="let c of clinic"[value]="c.id">{{c.name}}</option> 
                                                                </select>
                                                                
                                                        </div>
                                                    </div>
                                                   
                                </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <button type="submit" class="btn btn-success3 btn-block" [disabled]="!f1.valid">Confirm</button>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <button class="btn btn-success btn-block" routerLink="/doctor/manageschedule">Back To schedule</button>
                                    </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
